import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { patientGet } from "../core/patient";

export function usePatient(patientId: string) {
  const patientResource = useQuery(computed(() => patientGet(patientId)));
  return patientResource;
}
